import React from 'react'
import styled from 'styled-components'
import { style } from 'theme'
import CryptoBackground from 'assets/images/crypto.png'
import { Button } from '@acorns/web-components'
import { useHistory } from 'react-router-dom'
import { useAnalyticsClient, useRemoteStrings } from '@acorns/web-utils'
import usePortfolioData from 'pages/portfolio/hooks/usePortfolioData'
import { BitcoinEntryCardButtonTapped } from 'pages/portfolio/Crypto/events'
import { useTierSubscription } from 'hooks/useTierSubscription'

const Container = styled.div`
  width: 100%;
  margin-top: 30px;
  max-width: 450px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding: 30px 30px 40px;
    margin: 0 auto;
  }
`

const Card = styled.div`
  width: 100%;
  background:
    url(${CryptoBackground}) center no-repeat,
    ${style((theme) => theme.colors.greenDark)};
  background-size: 115% auto;
  padding: 30px;
  border-radius: ${style((theme) => theme.borderRadius.large)};
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    background-size: 130% auto;
    padding: 30px 0;
  }
`

const Title = styled.h1`
  margin: 0 auto 20px;
  text-align: center;
  max-width: 275px;
  font-size: 22px;
  line-height: 30px;
  color: ${style((theme) => theme.colors.white)};
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

const StyledButton = styled(Button)`
  width: 160px;
  margin: 0 auto;
`

interface Props {
  className?: string
  linkTo: string
}

export const CryptoCard = ({ className, linkTo }: Props) => {
  const { getRemoteString } = useRemoteStrings()
  const { currentProductPortfolio, portfolioDetails } = usePortfolioData()
  const history = useHistory()
  const analytics = useAnalyticsClient()
  const { subscriptionTierKey } = useTierSubscription()

  const onPress = () => {
    analytics.track(
      'Button Tapped',
      BitcoinEntryCardButtonTapped(
        currentProductPortfolio.toLowerCase(),
        portfolioDetails.currentPortfolioTheme,
        portfolioDetails.currentPortfolioRisk,
        subscriptionTierKey || '',
      ),
    )
    history.push(linkTo)
  }

  return (
    <Container className={className}>
      <Card>
        <Title>
          {getRemoteString({ key: 'invest.portfolio.new_etf_card.body' })}
        </Title>
        <StyledButton onPress={onPress} secondary>
          {getRemoteString({ key: 'invest.portfolio.new_etf_card.cta' })}
        </StyledButton>
      </Card>
    </Container>
  )
}
